// extracted by mini-css-extract-plugin
export var blogSearchBar = "searchBar-module--blogSearchBar--9a2a9";
export var blogSearchBarContent = "searchBar-module--blogSearchBarContent--1b1cb";
export var container = "searchBar-module--container--735e3";
export var searchBox = "searchBar-module--searchBox--abc47";